import React, { useContext } from 'react';
import { Button } from 'reactstrap';
import { BrandingContext, ContractContext } from '../contexts/ContractContext';
import styles from './DevelopmentBrandToggler.module.css';

const DevelopmentBrandToggler = () => {
    const context = useContext(BrandingContext);

    const handleSwitch = (id) => {
        context.updateClientId(id);
    };
    return (
        <div className={styles.brandTogglerContainer}>
            <p>Select Brand to Test:</p>
            <Button
                className='btn-primary ml-4'
                onClick={() => handleSwitch('NJR')}
            >
                NJR
            </Button>
            <Button
                className='btn-primary ml-4'
                onClick={() => handleSwitch('AIG')}
            >
                AIG
            </Button>
            <Button
                className='btn-primary ml-4'
                onClick={() => handleSwitch('DTC')}
            >
                DTC
            </Button>
            <Button
                className='btn-primary ml-4'
                onClick={() => handleSwitch('APPLE')}
            >
                Apple
            </Button>
        </div>
    );
};

export default DevelopmentBrandToggler;
